"use strict";

var _interopRequireDefault = require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _classCallCheck2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var SummaryTour = /*#__PURE__*/function (_Vue) {
  function SummaryTour() {
    var _this;
    (0, _classCallCheck2.default)(this, SummaryTour);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, SummaryTour, [].concat(args));
    (0, _defineProperty2.default)(_this, "form", void 0);
    return _this;
  }
  (0, _inherits2.default)(SummaryTour, _Vue);
  return (0, _createClass2.default)(SummaryTour, [{
    key: "fee",
    get: function get() {
      var fee = 0;
      this.form.dataTable.forEach(function (e) {
        if (e.shipFee) {
          fee += +e.shipFee;
        }
      });
      this.form.moneyShipFee = fee;
      return fee;
    }
  }, {
    key: "shopFee",
    get: function get() {
      var fee = 0;
      this.form.dataTable.forEach(function (e) {
        fee += e.calcTotalMoney - e.shipFee;
      });
      this.form.moneyReturnShop = fee;
      return fee;
    }
  }]);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  required: true
})], SummaryTour.prototype, "form", void 0);
SummaryTour = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], SummaryTour);
var _default = exports.default = SummaryTour;